$(function() {
    // 日期插件
    $('#time-picker-start, #time-picker-end').datetimepicker({
        format: 'yyyy-mm-dd',
        language:"zh-CN",
        minView:2,
        autoclose:true
    })

    // 验证码点击事件
    $('.verify-btn-js').click(function() {
        if ($(this).hasClass('disabled')) return
        let sec = 60
        let $el = $(this)
        let timer = null
        let text = '获取验证码'
        let $par = $(this).parents('form')
        let mobile = $par.find('[name="mobile"]').val()
        let $codIpt = $par.find('[name="code"]')
        let type = $(this).data('type') || 1
        if (!REG['phone'].rule.test(mobile)) {
            windowAlert('danger', '手机号格式错误')
            return
        }

        // type：1 注册
        // type: 2 密码找回
        $.get('/code/send', { mobile: mobile, type: type }, res => {
            if (res.status) {
                $el.addClass('disabled')
                $codIpt.removeAttr('disabled').focus()
                
                fn($el)
                windowAlert('success', res.message)
            } else {
                windowAlert('danger', res.message)
            }
            
        })

        function fn(el) {
            el.text(`${sec}s...`)
            sec -= 1
            if (sec < 0 && timer) {
                clearTimeout(timer)
                $el.removeClass('disabled').text(text)
                return
            }
            timer = setTimeout(() =>  fn($el), 1 * 1000)
        }
    })
    // 轮播
    $('.carousel').length > 0 && $('.carousel').carousel()
    $('.autoplay').length > 0 && $('.autoplay').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        prevArrow: '<a href="javascript:;" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></a>',
        nextArrow: '<a href="javascript:;" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></a>'
    })

    $('.autoplay-news').length > 0 && $('.autoplay-news').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        prevArrow: '<a href="javascript:;" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></a>',
        nextArrow: '<a href="javascript:;" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></a>'
    })

    $('#login-tab--js').click(function(e) {
        loginModalOpen()
    })

    $('#reg-tab--js').click(function(e) {
        regModalOpen()
    })

    // bs tooltip开启
    $('[data-toggle="tooltip"]').tooltip()

    $('.shipping-record-toggle-js').click(function() {
        $('.shipping-record').toggleClass('ac')
    })

    // 头部个人信息区域hover效果
    $('body').on('mouseenter', '.profile-dropdown', function(e) {
        $(this).find('.drop-block').show()
    })

    $('body').on('mouseleave', '.profile-dropdown', function(e) {
        $(this).find('.drop-block').hide()
    })

    // modal触发时 删除form tip
    $('[id$="Modal"]').on('hidden.bs.modal', function (e) {
        $(this).find('.border-warning').removeClass('border-warning')
        clearFormTips()
    })
    $('[id$="Modal"]').on('show.bs.modal', function (e) {
        $(this).find('.border-warning').removeClass('border-warning')
        clearFormTips()
    })
    $('#loginModal').on('hidden.bs.modal', function (e) {
        loginModalOpen()
    })

    // 登录modal触发
    // $('#loginModal').modal()

    // 图片验证码刷新
    $('.image-verify').click(function(e) {
        var timecode = new Date().getTime()
        var url = $(this).data('src')
        $(this).attr('src', `${url}?timecode=${timecode}`)
    })
})

function verifyCodeEvent(mobile, type) {
    // type：1 注册
    // type: 2 密码找回
    $.get('/code/send', { mobile: mobile, type: type }, res => {
        if (res.status) {
            windowAlert('success', res.message)
        } else {
            windowAlert('danger', res.message)
        }
        
    })
}

function cartPriceTabFix() {
    var $target = $('.cart-footer');
    var $container = $('.cart-footer-container');
    var elOuterHeight = $container.outerHeight();
    var targetOffset = $container.offset();
    var elPostionTop = targetOffset.top;
    var elPostionLeft = targetOffset.left;
    var windowScrollTop, winHeight, windowWidth = $(window).width(), changeWidth = 0;

    if (window.innerHeight) {
		winHeight = window.innerHeight;
	}else if ((document.body) && (document.body.clientHeight)) {
		winHeight = document.documentElement.clientHeight;
	}

    init();

    $(window).scroll(function(e) {
        init();
    })

    function init() {
        targetOffset = $container.offset();
        elPostionTop = targetOffset.top;
        elPostionLeft = targetOffset.left;
        windowScrollTop = $(window).scrollTop();
        
        changeWidth = windowWidth - $(window).width();
        windowWidth = $(window).width();

        if(elPostionTop + elOuterHeight > winHeight + windowScrollTop) {
            !$target.hasClass('fixed') && $target.addClass('fixed')
        }else {
            $target.hasClass('fixed') && $target.removeClass('fixed');
        }
    }
}

// 常规validate form
$('form[validateForm]').each(function(i, el) {
    var vf = new ValidateForm({
        el: el,
        submit: function(res) {
            
        }
    })

    vf.init()
})

// 常规登录ajax post
var login_vf = new ValidateForm({
    el: 'form[validateLoginForm]',
    submit_ajax: true,
    submit: function(res) {
        if (res.status) {
            setTimeout(() => window.location.href = '/', 1.5 * 1000)
        }
    }
})
login_vf.init()

// modal登录ajax post
// $('#loginModal').modal()
var login_modal_vf = new ValidateForm({
    el: 'form[validateModalLoginForm]',
    submit_ajax: true,
    submit: function(res) {
        modalLoginRegCommon(res)
    }
})
login_modal_vf.init()

var reg_modal_vf = new ValidateForm({
    el: 'form[validateModalRegForm]',
    submit_ajax: true,
    submit: function(res) {
        $('.reg-modal-alert').text(res.message).show()
        modalLoginRegCommon(res)
    }
})
reg_modal_vf.init()

function modalLoginRegCommon(res) {
    if (res.status) {
        makeupModalLoginHeader(res)
        
        if (vm_assembly) {
            setTimeout(() => vm_assembly.postFormReview(), 1000)
        }

        // 全局用户登录信息
        WINDOW_USER_INFO = {
            mobile: res.data.full_mobile,
            user_id: res.data.uid,
            nickname: res.data.nickname,
            company: res.data.company
        }
    }
}

function makeupModalLoginHeader(res) {
    var $header_unlogin = $('.header-bar .unlogin')
    var user_type = res.data.user_type
    var cart_html = res.data.cart_item_number > 0 ?
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <circle cx="6.1" cy="19.13" r="2" />
            <circle cx="18.1" cy="19.13" r="2" />
            <path d="M17.35,15.93H7.26a4.26,4.26,0,0,1-4.05-4.44v-6c0-.7-.17-.91-.21-1a.61.61,0,0,0-.4-.1H.6V1.83h2a3.06,3.06,0,0,1,2.25.87,3.7,3.7,0,0,1,1,2.76v6a1.7,1.7,0,0,0,1.45,1.84H17.35a1.7,1.7,0,0,0,1.45-1.84V3.63h2.6v7.86A4.26,4.26,0,0,1,17.35,15.93Z"
            />
            <rect x="7.78" y="0.87" width="9.32" height="2" rx="1" ry="1" />
            <rect x="7.78" y="4.87" width="9.32" height="2" rx="1" ry="1" />
            <rect x="7.78" y="8.87" width="9.32" height="2" rx="1" ry="1" />
        </svg> <span class="position-absolute">${res.data.cart_item_number}</span>` :
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
            <circle cx="6" cy="19" r="2"/>
            <circle cx="18" cy="19" r="2"/>
            <path d="M17.25,15.8H7.16a4.26,4.26,0,0,1-4.05-4.44v-6c0-.7-.17-.91-.21-1a.62.62,0,0,0-.4-.1H.5V1.7h2a3.06,3.06,0,0,1,2.25.87,3.7,3.7,0,0,1,1,2.76v6A1.7,1.7,0,0,0,7.16,13.2H17.25a1.7,1.7,0,0,0,1.45-1.84V7.18a1.7,1.7,0,0,0-1.45-1.84H8.54V2.75h8.71A4.26,4.26,0,0,1,21.3,7.18v4.18A4.26,4.26,0,0,1,17.25,15.8Z"/>
        </svg>`

    var html = `
        <div class="header-right login float-right">
            <div class="profile-dropdown">
                <div class="name-block">
                    <span class="text-truncate">${res.data.mobile}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                        <polygon points="11 14.56 5.29 8.86 6.71 7.44 11 11.73 15.29 7.44 16.7 8.85 11 14.56" />
                    </svg>
                </div>
                <div class="drop-block">
                    <i class="arrow-up-shadow"></i>
                    <i class="arrow-up"></i>
                    <ul>
                        <li><a href="/user/order_list">订单管理</a></li>
                        ${user_type ? '<li><a href="/user/open_order_list">放账订单</a></li>' : ''}
                        <li><a href="/user/assembly_quote_list">组装询价</a></li>
                        <li><a href="/user/profile">基本信息</a></li>
                        <li><a href="/user/change_password">修改密码</a></li>
                        <li><a href="/user/address">收货地址</a></li>
                        <li><a href="/user/logout">退出</a></li>
                    </ul>
                </div>
            </div>
            <a href="/cart" class="header-cart">
                ${cart_html}
            </a>
        </div>
    `

    $header_unlogin.before(html)
    $header_unlogin.remove()
    $('#loginModal').modal('hide')
}


$('body').on('mouseleave', '.validate_form_tip', function() {
    $(this).fadeOut(function(){
        $(this).remove()
    })
})

// 省市州选择框初始化
makeUpAreaSelect()
function makeUpAreaSelect() {
    var $box = $('.init_area_box')
    if (!$box.length) return
    var select_1 = $('<select class="form-control float-left" data-validate="require" name="province_id"></select>')
    var select_2 = $('<select class="form-control float-left center-margin" data-validate="require" name="city_id"></select>')
    var select_3 = $('<select class="form-control float-left" name="area_id"></select>')
    var select_1_options = '<option value="">选择省份</option>'
    var select_2_options = '<option value="">选择市</option>'
    var select_3_options = '<option value="">选择区域</option>'

    AREA_JSON.data.forEach(province => {
        select_1_options += `<option value="${province.id}">${province.name}</option>`
    })

    select_1.html(select_1_options)
    select_2.html(select_2_options)
    select_3.html(select_3_options)
    $box.append(select_1)
    $box.append(select_2)
    $box.append(select_3)

    $('body').on('change', 'select[name="province_id"]', function(e) {
        var v = $(this).val()
        var _otpions = '<option value="">选择市</option>'
        AREA_JSON.data.forEach(province => {
            if (province.id == v) {
                province.child.forEach(city => {
                    _otpions += `<option value="${city.id}">${city.name}</option>`
                })
            }
        })

        $box.find('select[name="city_id"]').html(_otpions)
        $box.find('select[name="area_id"]').html(select_3_options)

    })

    $('body').on('change', 'select[name="city_id"]', function(e) {
        var v0 = $(this).siblings('select[name="province_id"]').val()
        var v = $(this).val()
        var _otpions = '<option value="">选择区域</option>'
        AREA_JSON.data.forEach(province => {
            if (province.id == v0) {
                province.child.forEach(city => {
                    if (city.id == v) {
                        var has_child = city.child
                        if (has_child) {
                            city.child.forEach(area => {
                                _otpions += `<option value="${area.id}">${area.name}</option>`
                            }) 
                        }
                    }
                })
            }
        })
        $box.find('select[name="area_id"]').html(_otpions)
    })
    if (typeof PROVINCE_ID == 'undefined') return
    if (PROVINCE_ID && CITY_ID) {
        $('[name="province_id"]').val(PROVINCE_ID).trigger('change')
        $('[name="city_id"]').val(CITY_ID).trigger('change')
        // 部分地区无区域选择
        AREA_ID && $('[name="area_id"]').val(AREA_ID)
    }
}

// 全局window_alert提醒事件
let windowAlertTimer = null
function windowAlert(type = "success", text = "操作成功") {
    var $box = $('#window_alert_box')
    var $text = $box.find('span')
    var $content = $box.children('div')
    var cls =  `text-${type} `
    $text.text(text)
    $content.attr('class', cls)
    $box.addClass('ac')

    windowAlertTimer = setTimeout(() => $box.removeClass('ac'), 2.5 * 1000)
}

$('body').on('click', '#window_alert_box', function(e) {
    windowAlertTimer && clearTimeout(windowAlertTimer)
    $(this).removeClass('ac')
})

// 检查登录
function check_login(cb) {
    $.get('/user/context', res => {
        console.log(res)
        if (res.status) {
            cb && cb()
        } else {
            $('#loginModal').modal()
        }
    })
}

// 上传组件
$.fn.window_upload_comp = function(options) {
    var defaults = {
        success: function(res) {
            console.log('success:', res)
        },
        beforeSend: function() {
            console.log('before upload')
        }
    }
    var options = $.extend(defaults, options)

    this.each(function() {
        var $par = $(this)
        var $progress_bar = $par.find('.progress-bar')
        var $text_success = $par.find('.success-text')
        var $file_input = $par.find('input[type="file"]')
        var _url = '/file/upload'
        var $form = $par.parents('form')
        var $file = $form.find('input[type="hidden"].hidden_value')

        $file_input.change(function(e) {
            if(!$file_input[0].value) return
            $form.ajaxSubmit({
                url: _url,
                type: 'POST',
                beforeSend: options.beforeSend,
                uploadProgress: function(event, position, total, percentComplete) {
                    $progress_bar.css('width', percentComplete+'%')
                },
                success: function(res) {
                    if (res.status == 1) {
                        $par.attr('class', 'upload-file-comp ok')
                        $file.val(res.data)
                        $text_success.text(res.name)
                        windowAlert('success', res.info)
                        options.success(res)
                    } else {
                        $par.attr('class', 'upload-file-comp')
                        $file.val('')
                        $text_success.text('')
                        windowAlert('warning', res.info)
                    }
                },
                error: function() {
                    $par.attr('class', 'upload-file-comp')
                    $file.val('')
                    $text_success.text('服务器出错, 请稍后再试')
                    windowAlert('danger', '服务器出错, 请稍后再试')
                },
                complete: function(xhr) {
                    console.log(xhr)
                }
            })
        })
    })
}
function window_upload_comp(el, cb) {
    var $par = $(el)
    var $progress_bar = $par.find('.progress-bar')
    var $text_success = $par.find('.success-text')
    var $file_input = $par.find('input[type="file"]')
    var _url = '/file/upload'
    var $form = $(el).parents('form')
    var $file = $form.find('input[type="hidden"]')

    $file_input.change(function(e) {
        if(!$file_input[0].value) return

        // $par.attr('class', 'upload-file-comp uploading')
        console.log('enter', $file)
        $form.ajaxSubmit({
            url: _url,
            type: 'POST',
            beforeSend: function() {
                console.log('before upload')
            },
            uploadProgress: function(event, position, total, percentComplete) {
                $progress_bar.css('width', percentComplete+'%')
            },
            success: function(res) {
                if (res.status == 1) {
                    $par.attr('class', 'upload-file-comp ok')
                    $file.val(res.data)
                    $text_success.text(res.name)
                    windowAlert('success', res.info)
                    cb && cb(res)
                } else {
                    $par.attr('class', 'upload-file-comp')
                    $file.val('')
                    $text_success.text('')
                    windowAlert('warning', res.info)
                }
            },
            error: function() {
                $par.attr('class', 'upload-file-comp')
                $file.val('')
                $text_success.text('服务器出错, 请稍后再试')
                windowAlert('danger', '服务器出错, 请稍后再试')
            },
            complete: function(xhr) {
                console.log(xhr)
            }
        })
    })
    
}

$('.upload-file-comp').on('click', '.remove-btn[data-static]', function(e) {
    var $par = $(this).parents('.upload-file-comp').attr('class', 'upload-file-comp')
    $par.find('input[type="hiden"]').val('')
    $par.find('.text-success').text('')
    $par.find('.progress-bar').css('width', '0').text('')
})

// 组装询价成功弹层按钮时间
$('#assemblyQuoteModal').on('click', '.btn-success', e => {
    // 继续询价按钮 -> 重置表单
    vm_assembly.resetForm()
})
if (window.location.pathname.indexOf('/quote/') > -1) {
    $('.reg-btn--js')
        .attr('href', 'javascript:;')
        .click(function(e) {
            $('#loginModal').modal()
            regModalOpen()
            $('[name="code"]').attr('disabled', true)
        })
    
    $('.login-btn--js')
        .attr('href', 'javascript:;')
        .click(function(e) {
            $('#loginModal').modal()
            loginModalOpen()
        })
}
// 登录Modal初始化
function regModalOpen() {
    $('.reg-modal-alert').text('').hide()
    $('#login-tab').hide()
    $('#reg-tab').show()
    $('#logimModalLabel').text('注册')
}
// 注册Modal初始化
function loginModalOpen() {
    $('#login-tab').show()
    $('#reg-tab').hide()
    $('#logimModalLabel').text('登录')
}


// 购物车事件

if (window.location.pathname.indexOf('/cart') > -1) {
    var $allcheck = $('.allcheck')
    var $single = $('.single-check--js')
    var $totalBox = $('#total')
    var $itemCount = $('.item-count')
    var $removeItem = $('.remove-item')
    var $removeItems = $('.remove-items')
    var $submit = $('.btn-submit')
    var $cartForm = $('#cart-form')

    productInfoToggle()

    // 单个删除商品
    $removeItem.click(function(e) {
        if (!confirm('确定删除此商品？')) {
            return
        }
        var id = $(this).data('id')
        var $item = $(this).parents('.cart-item')
        remove_item(id, $item)
    })

    // 多选删除商品
    $removeItems.click(function(e) {
        if (!confirm('确定删除选中商品？')) {
            return
        }
        var $checks = $('.single-check--js:checked')
        var checks_id = []
        $checks.map(function(i, el) {
            checks_id.push(el.value) 
        })

        remove_item(checks_id, $checks.parents('.cart-item'))
        $itemCount.text(0)
    })
    
    // 删除商品
    function remove_item(id, elements) {
        $.get(`/cart/delele/cart_id/`, { cart_id: id }, function(res) {
            if (res.status) {
                windowAlert('success', '删除成功')
                changeCartCount('reduce', elements.length)
                elements.slideUp(300, function() {
                    $(this).remove()
                    getCheckedCount()
                })
            } else {
                windowAlert('danger', '删除失败, 请稍后再试')
            }
        })
    }

    // 结算验证
    $submit.click(function(e) {
        var $checkeds = $('.single-check--js:checked')
        if (!$checkeds.length) {
            windowAlert('warning', '请选择至少一件商品进行结算')
            return
        }
        if ($(this).hasClass('fetching')) return
        $(this).addClass('fetching')
        $cartForm.submit()
    })

    // 全选
    $allcheck.click(function(e) {
        var v = $(this).is(':checked')
        $allcheck.not(e.target).each(function(i, el) {
            el.checked = v
        })
        $single.each(function(i, el) {
              if (!v) {
                  el.checked = false
              } else {
                  el.checked = 'checked'
              }
          })
        getCartTotal()
        getCheckedCount()
    })
    // 商品checkbox 事件
    $single.change(function(e) {
        getCartTotal()
        activeAllCheck()
        getCheckedCount()
    })

    // 选中个数
    function getCheckedCount() {
        var $checkeds = $('.single-check--js:checked')
        $itemCount.text($checkeds.length || 0)
    }
    // 是否pick全选
    function activeAllCheck() {
        var $checkeds = $('.single-check--js:checked')
        var $checks = $('.single-check--js')
        if ($checkeds.length == $checks.length) {
            $allcheck.each(function(i, el) {
                el.checked = 'checked'
            })
        } else {
            $allcheck.each(function(i, el) {
                el.checked = false
            })
        }
    }
    // 获取选择商品总额
    function getCartTotal() {
        var $checksPar = $('.single-check--js:checked').parents('.cart-item')
        var total = 0
        $checksPar.each(function(i, el) {
            var v = $(el).data('total')
            if (v) {
                total += Number(v)
            }
        })
        total = total.toFixed(2)
        if (total > 0) {
            activeSubmit()
        } else {
            disableSubmit()
        }
        $totalBox.text(total)
    }
    // 激活购物车提交
    function activeSubmit() {
        $submit.removeAttr('disabled').removeClass('btn-secondary').addClass('btn-success')
    }

    // 屏蔽购物车提交
    function disableSubmit() {
        $submit.attr('disabled', true).removeClass('btn-success').addClass('btn-secondary')
    }

    // 商品详情预览
    function productInfoToggle() {
        var $btn = $('.product-name');
    
        $btn.click(function() {
            $(this).toggleClass('active');
            $(this).parents('.cart-item').siblings('.cart-item').find('.product-name').removeClass('active');
            $(this).parents('.cart-item').siblings('.cart-item').find('.product-info:visible').hide();
            $(this).parent().siblings('.product-info').toggle();
        })
    }
}

// 地址相关功能 添加收货地址 修改收货地址

// 添加地址
var $addAdressModal = $('#addAddressModal')
$('body').on('click', '.add-address-js', function() {
    $addAdressModal.modal()
})
// 新增地址modal显示时 清空表单
$addAdressModal.on('show.bs.modal', function(e) {
    $addAdressModal.find('input, textarea, select').val('')
})
var add_address_vf = new ValidateForm({
    el: '#validateAddAdressForm',
    method: 'POST',
    submit_ajax: true,
    submit: function(res) {
        if (res.status) {
            windowAlert('success', '操作成功')
            makeUpaddAddressHtml(res.data)
            $addAdressModal.modal('hide')
            // setTimeout( () => window.location.reload(), 1500)
        } else {
            windowAlert('danger', '新增地址失败, 请稍后再试')
        }
    }
})
add_address_vf.init()
function makeUpaddAddressHtml(data, is_update) {

    var html = ''
    if (data.is_default == '1') {
        $('.default-badge').addClass('d-none')
    }

    if (window.location.pathname == '/checkout/index' || window.location.pathname == '/user/create_open_order') {

        html = `<div class="address-item ac mb-2 clearfix">
        <div class="address-item-left float-left clearfix">
          <section class="base-radio float-left">
              <input value="${data.id}" type="radio" checked name="address_id" id="addressMethod${data.id}">
              <label class="mb-0" for="addressMethod${data.id}">${data.name}</label>
          </section>
          <div class="adress-item-content float-left">
            <span class="text-truncate d-inline-block">${data.province} ${data.city} ${data.area || ''} ${data.address}</span>
            <span class="pl-2 pr-2 text-truncate d-inline-block">${data.mobile}</span>  
          </div>
          <span class="badge default-badge float-left badge-success ${data.is_default == '1' ? '' : 'd-none'} ">默认地址</span>
        </div>
      
        <div class="pr-2 address-item-right float-right">
          <textarea data-address="" class="d-none">${data.json_data}</textarea>
          <a class="pr-2 modify-address-js" href="javascript:;" data-id="${data.id}">编辑</a>
          <a href="javascript:;" class="set-default--js" data-id="${data.id}">设为默认</a>
        </div>
      </div>`

      if ($('.no-address-box').length > 0) {
        $('.no-address-box').remove()
      }

      if (is_update) {
        var $el = $activeModifyElement.parents('.address-item')
        $el.after(html)
        $el.remove()
      }else {
        $('.address-item-box').prepend(html)
      }
    } else {
        html = `<div class="profile-address-item float-left default-address position-relative font-14">
        <span class="default-label badge default-badge badge-success  ${data.is_default == '1' ? '' : 'd-none'}">默认地址</span>
         <p class="adress-name text-dark font-20 mt-2 mb-2">${data.name}</p>
         <p class="adress-text">${data.province} ${data.city} ${data.area || ''}</p>
         <p class="adress-text mb-2">${data.address}</p>
         <p>邮编: ${data.postal_code}</p>
         <p>手机: ${data.mobile}</p>
         <p>公司: ${data.company}</p>
         <p>固定电话: ${data.phone}</p>
         <div class="btns text-right">
           <textarea data-address="" class="d-none">>${data.json_data}</textarea>
           <a class="text-warning-1 modify-address-js" href="javascript:;" data-id="${data.id}">编辑</a>
           <a class="text-warning-1 remove-address--js" href="javascript:;" data-id="${data.id}">删除</a>
           <a href="javascript:;" class="set-default--js" data-id="${data.id}">默认地址</a>                
         </div>
       </div>`

        if (is_update) {
            var $el = $activeModifyElement.parents('.profile-address-item')
            $el.after(html)
            $el.remove()
        }else {
            $('.profile-address-item:last').after(html)
        }
    }
}

// 修改地址
var $modifyAddressModal = $('#editAddressModal')
var $activeModifyElement = null
var modifyAddressClass = '.modify-address-js'
$('body').on('click', modifyAddressClass, function(e) {
    e.stopPropagation()

    $activeModifyElement = $(this)

    var address_json = JSON.parse($(this).siblings('[data-address]').text())

    $modifyAddressModal.find('[name="id"]').val(address_json.id)
    $modifyAddressModal.find('[name="name"]').val(address_json.name)
    $modifyAddressModal.find('[name="phone"]').val(address_json.phone)
    $modifyAddressModal.find('[name="mobile"]').val(address_json.mobile)
    $modifyAddressModal.find('[name="company"]').val(address_json.company)

    $modifyAddressModal.find('[name="province_id"]').val(address_json.province_id).trigger('change')
    $modifyAddressModal.find('[name="city_id"]').val(address_json.city_id).trigger('change')
    $modifyAddressModal.find('[name="area_id"]').val(address_json.area_id)

    $modifyAddressModal.find('[name="address"]').val(address_json.address)
    $modifyAddressModal.find('[name="postal_code"]').val(address_json.postal_code)
    $modifyAddressModal.find('[name="is_default"]').val(address_json.is_default)

    if (Number(address_json.is_default)) {
        $modifyAddressModal.find('[name="is_default"]').siblings('[type="checkbox"]')[0].checked = true
    } else {
        $modifyAddressModal.find('[name="is_default"]').siblings('[type="checkbox"]')[0].checked = false
    }

    $modifyAddressModal.modal()
})

var edit_address_vf = new ValidateForm({
    el: '#validateEditAdressForm',
    method: 'POST',
    submit_ajax: true,
    submit: function(res) {
        if (res.status) {
            windowAlert('success', '操作成功')
            $activeModifyElement.parents
            makeUpaddAddressHtml(res.data, true)
            $modifyAddressModal.modal('hide')
            // setTimeout( () => window.location.reload(), 1500)
        } else {
            windowAlert('danger', '修改地址失败, 请稍后再试')
        }
    }
})
edit_address_vf.init()

// 删除地址
var removeAddrssClass = '.remove-address--js'
$('body').on('click', removeAddrssClass, function(e) {
    if (!confirm('确认删除此地址？')) {
        return
    }
    var $el = $(this)
    var $par = $el.parents('.profile-address-item')
    $.get('/address/delete', {id: $el.data('id')}, function(res) {
        if (res.status) {
            windowAlert('success', '操作成功')
            $par.slideUp(400, function() {
                $par.remove()
            })
        } else {
            windowAlert('danger', '修改地址失败, 请稍后再试')
        }
    })
})

// 设为默认
var setDefaultAddrssClass = '.set-default--js'
$('body').on('click', setDefaultAddrssClass, function(e) {
    var $el = $(this)
    $.get('/address/setDefault', {id: $el.data('id')}, function(res) {
        if (res.status) {
            windowAlert('success', '操作成功')

            var $defaultAddress = null
            
            if (window.location.pathname == '/checkout/index' || window.location.pathname == '/user/create_open_order') {
                $defaultAddress =  $el.parents('.address-item')
            } else {
                $defaultAddress = $el.parents('.profile-address-item')
            }
            $('.default-badge').addClass('d-none')
            $defaultAddress.find('.default-badge').removeClass('d-none')

        } else {
            windowAlert('danger', '操作失败, 请稍后再试')
        }
    })
})

// 默认地址勾选框事件
$('[name="is_default"]').siblings('[type="checkbox"]').change(function(e) {
    var v = $(this).is(':checked')
    if (v) {
        $(this).siblings('[name="is_default"]').val('1')
    } else {
        $(this).siblings('[name="is_default"]').val('0')
    }
})

// 支付页面index

// 收货地址选择高亮
$('#shippingAddressChoice').on('click', '.address-item', function(e) {
    e.preventDefault()
    var $radio = $(this).find('[type="radio"]')
    $(this).addClass('ac').siblings('.address-item').removeClass('ac')
    $radio[0].checked = true
})

if (window.location.pathname.indexOf('/checkout/index') > -1) {
    // 收货地址 更多地址切换
    
    $('.more-address-js').click(function(e) {
        $(this).toggleClass('open')
        $('.address-item-box').toggleClass('open')
    })

    var $checkoutForm = $('#checkout-form')
    var $submit = $checkoutForm.find('.btn-submit')
    $submit.click(function(e) {
        var pick_address = $('.address-item.ac')
        if (!pick_address.length) {
            windowAlert('warning', '请选择收货地址')
            return
        }

        if ($(this).hasClass('fetching')) return

        var $invoiceModalElements = $invoiceModal.find('input, select, textarea').clone(true)
        $invoiceModalElements = $('<div class="d-none"></div>').append($invoiceModalElements)
        $checkoutForm.append($invoiceModalElements)

        $(this).addClass('fetching')
        $checkoutForm.submit()
    })
}

if (window.location.pathname.indexOf('/checkout/payment/order_number/') > -1) {
    var $paymentForm = $('#payment-form')
    var $submit = $paymentForm.find('.btn-submit')

    $submit.click(function(e) {
        $('#checkoutPaymentModal').modal()
        $paymentForm.submit()
    })

    $('#payment-tabs a').on('click', function (e) {
        e.preventDefault()
        $(this).tab('show')
    })

    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
        if (e.target.id == 'payment-offline-tab') {
            $paymentForm.find('.btn-submit').hide()
        } else {
            $paymentForm.find('.btn-submit').show()
        }
    })
}

// 商品加入购物车按钮事件
$('.quote-add-cart--js').click(function(e) {
    var url = $(this).data('url')
    $.get(url, res => {
        if (res.status) {
            changeCartCount('add')
            windowAlert('success', '加入购物车成功')
        } else {
            windowAlert('warning', '加入购物车失败, 请稍后再试')
        }
        
    })
})

function changeCartCount(type, c = 1) {
    var $countEl = $('.header-cart .position-absolute')
    if (typeof type == 'number') {
        $countEl.text(type)
        return
    }
    var count = $countEl.text() * 1
    if (type == 'reduce') {
        count -= c
    } else if(type == 'add') {
        count += c
    }
    
    if (count < 0) count = 0
    $countEl.text(count)
}

// 快递追踪
void function(){
    var $shipping_track_box = $('[data-track-token]')
    if ($shipping_track_box.length > 0) {
        var track_token = $shipping_track_box.data('track-token')
        if (!track_token.length) return 
        var $track_html_box = $('.shipping-record--box')
        $.get('/delivery/tracking/code/' + track_token, res => {
            var track_html = []
            if (res.success) {
                if (res.data.length) {
                    track_html = res.data.map((item, i) => {
                        return `<div class="shipping-record-item justify-content-start"><span class="time-code mr-4">${item.time}</span> ${item.context}</div>`
                    })
                }
            }

            if (!track_html.length) {
                var _no_html = `<span class="time-code mr-4">${res.reason || res.message || '快递公司网络异常，请稍后查询或去官网查询。'}</span>`
                // if (res.tracking_url) _no_html += `<a target="blank" href="${res.tracking_url}">尝试手动查询</a>`
                track_html.push(`<div class="shipping-record-item justify-content-start text-secondary">${_no_html}</div>`)
            }

            $('.shipping-tracking-loader').remove()
            $track_html_box.prepend(track_html.join(''))

        }, 'JSONP')
    }
}()
// 支付页面发票相关
var $invoiceModal = $('#invoiceModal')

$('.plx--js').click(function(e) {
    var val = $('.plx--js:checked').val()
    clearFormTips()
    if (val == '0') {
        $('.b1').show()
        $('.b2').hide()
    } else if( val == '1') {
        $('.b1').hide()
        $('.b2').show()
    } else {
        $('.b1').hide()
        $('.b2').hide()
    }
})

$('.ptt--js').click(function(e) {
    var val = $('.ptt--js:checked').val()
    if (val == '0') {
        $('.ptt').hide()
    } else {
        $('.ptt').show()
    }
})

var invoiceModalInit = false
$invoiceModal.on('show.bs.modal', function(e) {
    if (!invoiceModalInit) {
        invoiceModalInit = true
        $('.b2, .ptt').hide()
    }
})

const array_to_obj = arr => arr.reduce((t, v) => {t[v.name] = v.value; return t}, {})

// invoice modal 表单验证
var invoice_modal_b1_vf = new ValidateForm({
    el: 'form.b1',
    scroll_focus: false,
    submit_ajax: true,
    submit: function(res) {}
})
invoice_modal_b1_vf.init()

var invoice_modal_b2_vf = new ValidateForm({
    el: 'form.b2',
    submit_ajax: true,
    scroll_focus: false,
    submit: function(res) {}
})
invoice_modal_b2_vf.init()

$('.invoice-submit--js').click(function(e) {
    var invoiceType = $('.plx--js:checked').val()
    var invoiceTitle = $('.ptt--js:checked').val()
    var data = { type: invoiceType }
    if (invoiceType == '0') {
        if (invoiceTitle == '1' && !invoice_modal_b1_vf.to_all()) {
            return
        }
        
        data = Object.assign(data, array_to_obj($('.b1').serializeArray())) 
    } else if (invoiceType == '1') {
        if (!invoice_modal_b2_vf.to_all()) {
            return
        }
        data = Object.assign(data, array_to_obj($('.b2').serializeArray())) 
    }

    $.post('/invoice/add', data,  res => {
        if (res.status) {
            windowAlert('success', '修改成功')
            getInvoiceContent()
            $invoiceModal.modal('hide')
            rewriteCheckoutTotal(res.data)
        }
    })
})

function rewriteCheckoutTotal(data) {
    var $tax_html = $('#tax-html-box')
    var $item_total_html = $('#item-total-html-box')
    var $total_html = $('#total-html-box')
    var symbol = '&yen;'

    $tax_html.html(`${symbol} ${data.tax}`)
    $item_total_html.html(`${symbol} ${data.itemTotal}`)
    $total_html.html(`${symbol} ${data.total}`)
}

function getInvoiceContent() {
    var $contentBox = $('.invoice-info-box--js')
    var invoiceType = $('.plx--js:checked').val()
    var invoiceTitle = $('.ptt--js:checked').val()
    var type_html = $('.plx--js:checked').siblings('label').text()
    var title_html = ''

    if (invoiceType == '0') {
        title_html = invoiceTitle == '1' ? $('.b1 input[name="ele_company_name"]').val() : '个人'
    } else if (invoiceType == '1') {
        title_html = $('.b2 input[name="vat_company_name"]').val()
    } else {
        title_html = ''
    }

    var html = `<div class="float-left text-right pr-2">${type_html} </div>
  <div class="float-left text-right text-muted pl-4 pr-4 text-center">${title_html}</div> `
  $contentBox.html(html)

}

// 支付
void function(){
    // 支付失败按钮事件
    $('#checkout-status-failed--js').click(function(e) {
        $('#payment-error-status-block').removeClass('d-none')
        $('#checkoutPaymentModal').modal('hide')
    })

    $('#payment-online-btn').click(function(e) {
        var track_data = TrackerOrderInfo
        gaTracker(track_data)
    })
}()

function gaTracker(track_data) {

    ga('ecommerce:addTransaction', {
        'id': track_data.order_number,                     // Transaction ID. Required.
        'revenue': track_data.total,               // Grand Total.
        'shipping': track_data.shipping_cost,                  // Shipping.
        'tax': track_data.tax                     // Tax.
    })

    track_data.order_items.forEach((el, index) => {
        ga('ecommerce:addItem', {
            'id': el.id,                     // Transaction ID. Required.
            'name': el.product_name,    // Product name. Required.
            'sku': el.product_id,                 // SKU/code.
            'price': el.price,                 // Unit price.
            'quantity': el.amount                   // Quantity.
        })
    })
    
    ga('ecommerce:send')
}

// 清楚表单验证提示
function clearFormTips() {
    $('.validate_form_tip').remove()
}

// 文章页面左侧导航
// void function() {
//     var $article_nav = $('.article-left-side')
//     $article_nav.addClass('position-fixed')

//     $(window).resize(function() {
//         reposition($article_nav.offset())
//     })
    
//     function reposition(pos) {
//         $article_nav.css(pos)
//     }
// }()

